import React, {useEffect, useState} from 'react';
import {useTabsAtom} from '../../atoms/useTabsAtom';
import {useSelectedTabAtom} from '../../atoms/useSelectedTabAtom';
import {useTranslation} from 'react-i18next';
import ChatComponent from './ChatComponent';
import {IntentEnum} from "../../enums/IntentEnum";
import {compareNorms} from "../../api/questionAPIs";
import ComparePromptEditComponent from "./ComparePromptEditComponent";

const ChatWindow = ({chapter, sourceText, compareResult}) => {
    const [t,] = useTranslation('global');

    const [tabs] = useTabsAtom();
    const [selectedTab, setSelectedTab] = useSelectedTabAtom();
    const [compare, setCompare] = useState(null);

    const tabsLength = tabs.length;

    useEffect(() => {

        console.log('chapter', chapter);
        console.log('sourceText', sourceText);

    }, [chapter, sourceText]);

    useEffect(() => {

        console.log('compareResult', compareResult);
        setCompare(compareResult);

    }, [compareResult]);

    useEffect(() => {
        console.log('selected tab', selectedTab);
        if (selectedTab === IntentEnum.SendQuestion && !compareResult) {
            setTimeout(async () => {await handleCompare()}, 0);
        }
    }, [selectedTab]);

    const handleTabClick = (intent) => {
        console.log('handleTabClick', intent);
        setSelectedTab(intent);
    };

    const handleCompare = async () => {
        const result = await compareNorms(sourceText, chapter);
        console.log('compareResult', result);
        setCompare(result);
    }

    return (
        <>
            <div id="msgerWindow" className="chat-wrapper">

                <div className='tab-menu-bar'>
                    {tabsLength > 1 &&
                        <div className="tabs-wrapper">
                            <div className="tabs">
                                {tabs.map((tab) => (
                                    <React.Fragment key={tab.radio}>
                                        <input
                                            type="radio"
                                            id={`${tab.radio}`}
                                            name="tabs"
                                            checked={selectedTab === tab.intent}
                                            onChange={() => handleTabClick(tab.intent)}
                                        />
                                        <label className="tab" htmlFor={`${tab.radio}`}>
                                                            <span
                                                                className="material-symbols-outlined mobileOnly">{tab.icon}</span>
                                            <span className='pcOnly'>{t(tab.label)}</span>
                                        </label>
                                    </React.Fragment>
                                ))}
                                <span className="glider"></span>
                            </div>
                        </div>
                    }
                </div>

                <section className="msger">
                    <div className='msger-logo-wrapper'>
                        <div className='msger-logo'>
                            <div className="milladaTitle">
                                Mi<span className="stripe-1">l</span>
                                <span className="stripe-2">l</span>ada
                            </div>
                        </div>
                    </div>
                    {selectedTab === IntentEnum.SendQuestion &&  <div className="compare-prompt-wrapper">
                        <ComparePromptEditComponent />
                    </div>}
                    <ChatComponent chapter={chapter} sourceText={sourceText} compareResult={compare}/>
                </section>
            </div>
        </>
    );
};

export default ChatWindow;
